import { render, staticRenderFns } from "./PanelContentItemShowTabular.vue?vue&type=template&id=d535b1ec&"
import script from "./PanelContentItemShowTabular.vue?vue&type=script&lang=ts&"
export * from "./PanelContentItemShowTabular.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'directives', {ClosePopup});
